import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updatePmnFunctionsState from './pmnFunctions';

export default (state = initialState, action) => chooseReducer(state, action, updatePmnFunctionsState);
